import { BUILDING_STATUS } from "../constants";

const ukLocaitons = [
  { lat: 53.19146, long: -2.52398 },
  { lat: 53.69786, long: -2.68758 },
  { lat: 53.69786, long: -2.52751 },
  { lat: 53.00974, long: -3.0581 },
];

const germanyLocations = [
  { lat: 51.1657, long: 10.4515 },
  { lat: 51.2657, long: 10.6515 },
  { lat: 52.31, long: 13.23 },
  { lat: 52.38, long: 13.33 },
  { lat: 53.33, long: 10 },
  { lat: 48.8, long: 11.34 },
];

const usLocations = [
  { lat: 40.66, long: -73.93 },
  { lat: 42.89, long: -78.85 },
  { lat: 43.16, long: -77.61 },
  { lat: 41.83, long: -87.68 },
  { lat: 29.47, long: -98.52 },
  { lat: 32.79, long: -96.76 },
  { lat: 32.89, long: -96.86 },
  { lat: 30.3, long: -97.75 },
  { lat: 32, long: -98.52 },
  { lat: 41.83, long: -87.68 },
  { lat: 40, long: -75.13 },
  { lat: 39.3, long: -76.61 },
  { lat: 39.39, long: -76.69 },
  { lat: 39.2, long: -76.86 },
  { lat: 41.76, long: -88.29 },
  { lat: 41.51, long: -88.14 },
  { lat: 40.72, long: -74.17 },
  { lat: 40.82, long: -74.27 },
  { lat: 40.71, long: -74.06 },
  { lat: 40.91, long: -74.16 },
  { lat: 40.75, long: -89.61 },
  { lat: 39.6365, long: -74.8 },
  { lat: 39.7365, long: -74.9 },
];

const createPropertiesWithStatus = (statuses) => {
  const results = [];
  [...ukLocaitons, ...germanyLocations, ...usLocations].forEach((location, index) => {
    results.push({ ...location, status: statuses[index % statuses.length] });
  });
  return results;
};

export const properties = [
  createPropertiesWithStatus([
    BUILDING_STATUS.VACANCY_RATE,
    BUILDING_STATUS.UNCONNECTED_TENANTS,
    undefined,
  ]),
  createPropertiesWithStatus([
    BUILDING_STATUS.EXPECTED_GROWTH,
    BUILDING_STATUS.DECREASING_CONSUMPTION,
    BUILDING_STATUS.SUSPICIOUS_USAGE_IN_PREMISES,
    undefined,
  ]),
  createPropertiesWithStatus([
    BUILDING_STATUS.HIGHEST_CARBON_REDUCTION,
    BUILDING_STATUS.HIGHEST_CARBON_REDUCTION_POTENTIAL,
    BUILDING_STATUS.LOWEST_CARBON_REDUCTION,
    undefined,
  ]),
  createPropertiesWithStatus([
    BUILDING_STATUS.BEST_FIT_FOR_BATTERY,
    BUILDING_STATUS.BEST_FIT_FOR_SOLAR,
    BUILDING_STATUS.BEST_FIT_FOR_EV,
    undefined,
  ]),
  createPropertiesWithStatus([
    BUILDING_STATUS.INEFFICIENT_APPLIANCE,
    BUILDING_STATUS.MAINTENANCE_REQUESTED,
    BUILDING_STATUS.MAINTENANCE_ALERTS,
    undefined,
  ]),
];

export const consumptionData = [
  { x: "Jan", trading: 34, battery: 5, ev: 5 },
  { x: "Feb", trading: 36, battery: 5, ev: 5 },
  { x: "Mar", trading: 40, battery: 5, ev: 5 },
  { x: "Apr", trading: 45, battery: 5, ev: 5 },
  { x: "May", trading: 50, battery: 5, ev: 5 },
  { x: "Jun", trading: 60, battery: 5, ev: 5 },
  { x: "July", trading: 70, battery: 5, ev: 5 },
  { x: "Aug", trading: 35, battery: 5, ev: 5 },
  { x: "Sep", trading: 25, battery: 5, ev: 5 },
  { x: "Oct", trading: 11, battery: 5, ev: 5 },
  { x: "Nov", trading: 8, battery: 5, ev: 5 },
  { x: "Dec", trading: 5, battery: 5, ev: 5 },
];

export const consumptionDataForExpectedGrowth = [
  { x: "Jan", trading: 34, battery: 5, ev: 5 },
  { x: "Feb", trading: 36, battery: 5, ev: 5 },
  { x: "Mar", trading: 40, battery: 5, ev: 5 },
  { x: "Apr", trading: 45, battery: 5, ev: 5 },
  { x: "May", trading: 50, battery: 5, ev: 5 },
  { x: "Jun", trading: 60, battery: 5, ev: 5 },
  { x: "July", trading: 70, battery: 5, ev: 5 },
  { x: "Aug", trading: 80, battery: 5, ev: 5 },
  { x: "Sep", trading: 90, battery: 5, ev: 5 },
  { x: "Oct", trading: 100, battery: 5, ev: 5 },
  { x: "Nov", trading: 120, battery: 5, ev: 5 },
  { x: "Dec", trading: 135, battery: 5, ev: 5 },
];

export const suspiciousConsumptionData = [
  { x: "12am", consumption: 450 },
  { x: "12pm", consumption: 100 },
  { x: "12am", consumption: 450 },
];

export const accEmissionReduction = [
  { x: "Portfolio avg.", trading: 34, battery: 5, ev: 5, total: 44 },
  { x: "This building", trading: 134, battery: 5, ev: 5, total: 144 },
];

export const accCarbonRevernues = [
  { x: "Portfolio avg.", trading: 8000, battery: 1000, ev: 800, total: 9800 },
  { x: "This building", trading: 12000, battery: 800, ev: 200, total: 13000 },
];

export const expectedEmissionReductionPotential = [
  {
    trading: 34,
    battery: 5,
    ev: 5,
    additional_emission: 0,
    total: 44,
  },
  {
    trading: 134,
    battery: 5,
    ev: 5,
    additional_emission: 12,
    total: 156,
  },
];

export const expectedCarbonRevernuesPotential = [
  { trading: 8000, battery: 1000, ev: 800, total: 9800 },
  {
    trading: 12000,
    battery: 1000,
    ev: 800,
    additional_carbon_rev: 600,
    additional_pwr_rev: 600,
    total: 15000,
  },
];

export const expectedEmissionReductionLCR = [
  {
    trading: 34,
    battery: 5,
    ev: 5,
    additional_emission: 0,
    total: 44,
  },
  {
    trading: 20,
    additional_emission: 6,
    total: 26,
  },
];

export const expectedCarbonRevernuesLCR = [
  { trading: 8000, battery: 900, ev: 900, total: 9800 },
  {
    trading: 7600,
    battery: 900,
    ev: 500,
    additional_carbon_rev: 300,
    additional_pwr_rev: 300,
    total: 9600,
  },
];

export const bestFitForBatteries = {
  part1: [
    { text: "Power capacity", value: "200 kWh" },
    { text: "Baterries output", value: "105 kW" },
    { text: "Traded kWh/year", value: "146,000 kWh" },
    { text: "Total Cost", value: "$XXX" },
  ],
  part2: [
    { text: "Your Investment", value: "$0" },
    { text: "New Power revenue (expected)", value: "$YYY" },
  ],
};

export const bestFitForSolar = {
  part1: [
    { text: "Power capacity", value: "50 kWp" },
    { text: "Traded kWh/year", value: "80,000 kWh" },
    { text: "Total Cost", value: "$XXX" },
  ],
  part2: [
    { text: "Your Investment", value: "$0" },
    { text: "New Power revenue (expected)", value: "$YYY" },
  ],
};
